(function (global, factory) {
  typeof exports === 'object' && typeof module !== 'undefined' ? factory(exports, require('react')) :
  typeof define === 'function' && define.amd ? define(['exports', 'react'], factory) :
  (global = typeof globalThis !== 'undefined' ? globalThis : global || self, factory(global.ImageKitReact = {}, global.React));
})(this, (function (exports, React) { 'use strict';

  function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

  var React__default = /*#__PURE__*/_interopDefaultLegacy(React);

  function _typeof$1(obj) {
    "@babel/helpers - typeof";

    if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
      _typeof$1 = function (obj) {
        return typeof obj;
      };
    } else {
      _typeof$1 = function (obj) {
        return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
      };
    }
    return _typeof$1(obj);
  }
  function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
      throw new TypeError("Cannot call a class as a function");
    }
  }
  function _defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }
  function _createClass(Constructor, protoProps, staticProps) {
    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
    if (staticProps) _defineProperties(Constructor, staticProps);
    return Constructor;
  }
  function _defineProperty$1(obj, key, value) {
    if (key in obj) {
      Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
      });
    } else {
      obj[key] = value;
    }
    return obj;
  }
  function ownKeys$1(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
      var symbols = Object.getOwnPropertySymbols(object);
      if (enumerableOnly) symbols = symbols.filter(function (sym) {
        return Object.getOwnPropertyDescriptor(object, sym).enumerable;
      });
      keys.push.apply(keys, symbols);
    }
    return keys;
  }
  function _objectSpread2$1(target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i] != null ? arguments[i] : {};
      if (i % 2) {
        ownKeys$1(Object(source), true).forEach(function (key) {
          _defineProperty$1(target, key, source[key]);
        });
      } else if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
      } else {
        ownKeys$1(Object(source)).forEach(function (key) {
          Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
      }
    }
    return target;
  }
  function _unsupportedIterableToArray$1(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray$1(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray$1(o, minLen);
  }
  function _arrayLikeToArray$1(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i];
    return arr2;
  }
  function _createForOfIteratorHelper(o, allowArrayLike) {
    var it;
    if (typeof Symbol === "undefined" || o[Symbol.iterator] == null) {
      if (Array.isArray(o) || (it = _unsupportedIterableToArray$1(o)) || allowArrayLike && o && typeof o.length === "number") {
        if (it) o = it;
        var i = 0;
        var F = function () {};
        return {
          s: F,
          n: function () {
            if (i >= o.length) return {
              done: true
            };
            return {
              done: false,
              value: o[i++]
            };
          },
          e: function (e) {
            throw e;
          },
          f: F
        };
      }
      throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
    }
    var normalCompletion = true,
      didErr = false,
      err;
    return {
      s: function () {
        it = o[Symbol.iterator]();
      },
      n: function () {
        var step = it.next();
        normalCompletion = step.done;
        return step;
      },
      e: function (e) {
        didErr = true;
        err = e;
      },
      f: function () {
        try {
          if (!normalCompletion && it.return != null) it.return();
        } finally {
          if (didErr) throw err;
        }
      }
    };
  }
  var version = "3.0.0";
  var errorMessages = {
    MANDATORY_INITIALIZATION_MISSING: {
      message: "Missing urlEndpoint during SDK initialization",
      help: ""
    },
    INVALID_TRANSFORMATION_POSITION: {
      message: "Invalid transformationPosition parameter",
      help: ""
    },
    PRIVATE_KEY_CLIENT_SIDE: {
      message: "privateKey should not be passed on the client side",
      help: ""
    },
    MISSING_UPLOAD_DATA: {
      message: "Missing data for upload",
      help: ""
    },
    MISSING_UPLOAD_FILE_PARAMETER: {
      message: "Missing file parameter for upload",
      help: ""
    },
    MISSING_UPLOAD_FILENAME_PARAMETER: {
      message: "Missing fileName parameter for upload",
      help: ""
    },
    MISSING_AUTHENTICATION_ENDPOINT: {
      message: "Missing authentication endpoint for upload",
      help: ""
    },
    MISSING_PUBLIC_KEY: {
      message: "Missing public key for upload",
      help: ""
    },
    AUTH_ENDPOINT_TIMEOUT: {
      message: "The authenticationEndpoint you provided timed out in 60 seconds",
      help: ""
    },
    AUTH_ENDPOINT_NETWORK_ERROR: {
      message: "Request to authenticationEndpoint failed due to network error",
      help: ""
    },
    AUTH_INVALID_RESPONSE: {
      message: "Invalid response from authenticationEndpoint. The SDK expects a JSON response with three fields i.e. signature, token and expire.",
      help: ""
    },
    UPLOAD_ENDPOINT_NETWORK_ERROR: {
      message: "Request to ImageKit upload endpoint failed due to network error",
      help: ""
    },
    INVALID_UPLOAD_OPTIONS: {
      message: "Invalid uploadOptions parameter",
      help: ""
    },
    MISSING_SIGNATURE: {
      message: "Missing signature for upload. The SDK expects token, sginature and expire for authentication.",
      help: ""
    },
    MISSING_TOKEN: {
      message: "Missing token for upload. The SDK expects token, sginature and expire for authentication.",
      help: ""
    },
    MISSING_EXPIRE: {
      message: "Missing expire for upload. The SDK expects token, sginature and expire for authentication.",
      help: ""
    },
    INVALID_TRANSFORMATION: {
      message: "Invalid transformation parameter. Please include at least pre, post, or both.",
      help: ""
    },
    INVALID_PRE_TRANSFORMATION: {
      message: "Invalid pre transformation parameter.",
      help: ""
    },
    INVALID_POST_TRANSFORMATION: {
      message: "Invalid post transformation parameter.",
      help: ""
    }
  };
  function respond(isError, response, callback) {
    if (typeof callback == "function") {
      if (isError) {
        callback(response, null);
      } else {
        callback(null, response);
      }
    }
  }
  function getResponseHeaderMap(xhr) {
    var headers = {};
    var responseHeaders = xhr.getAllResponseHeaders();
    if (Object.keys(responseHeaders).length) {
      responseHeaders.trim().split(/[\r\n]+/).map(function (value) {
        return value.split(/: /);
      }).forEach(function (keyValue) {
        headers[keyValue[0].trim()] = keyValue[1].trim();
      });
    }
    return headers;
  }
  var addResponseHeadersAndBody = function addResponseHeadersAndBody(body, xhr) {
    var response = _objectSpread2$1({}, body);
    var responseMetadata = {
      statusCode: xhr.status,
      headers: getResponseHeaderMap(xhr)
    };
    Object.defineProperty(response, "$ResponseMetadata", {
      value: responseMetadata,
      enumerable: false,
      writable: false
    });
    return response;
  };
  var request = function request(uploadFileXHR, formData, callback) {
    uploadFile(uploadFileXHR, formData).then(function (result) {
      return respond(false, result, callback);
    }, function (ex) {
      return respond(true, ex, callback);
    });
  };
  var uploadFile = function uploadFile(uploadFileXHR, formData) {
    return new Promise(function (resolve, reject) {
      uploadFileXHR.open('POST', 'https://upload.imagekit.io/api/v1/files/upload');
      uploadFileXHR.onerror = function (e) {
        return reject(errorMessages.UPLOAD_ENDPOINT_NETWORK_ERROR);
      };
      uploadFileXHR.onload = function () {
        if (uploadFileXHR.status === 200) {
          try {
            var body = JSON.parse(uploadFileXHR.responseText);
            var uploadResponse = addResponseHeadersAndBody(body, uploadFileXHR);
            return resolve(uploadResponse);
          } catch (ex) {
            return reject(ex);
          }
        } else {
          try {
            var body = JSON.parse(uploadFileXHR.responseText);
            var uploadError = addResponseHeadersAndBody(body, uploadFileXHR);
            return reject(uploadError);
          } catch (ex) {
            return reject(ex);
          }
        }
      };
      uploadFileXHR.send(formData);
    });
  };
  var upload = function upload(xhr, uploadOptions, options, callback) {
    if (!uploadOptions.file) {
      respond(true, errorMessages.MISSING_UPLOAD_FILE_PARAMETER, callback);
      return;
    }
    if (!uploadOptions.fileName) {
      respond(true, errorMessages.MISSING_UPLOAD_FILENAME_PARAMETER, callback);
      return;
    }
    if (!options.publicKey) {
      respond(true, errorMessages.MISSING_PUBLIC_KEY, callback);
      return;
    }
    if (!uploadOptions.token) {
      respond(true, errorMessages.MISSING_TOKEN, callback);
      return;
    }
    if (!uploadOptions.signature) {
      respond(true, errorMessages.MISSING_SIGNATURE, callback);
      return;
    }
    if (!uploadOptions.expire) {
      respond(true, errorMessages.MISSING_EXPIRE, callback);
      return;
    }
    if (uploadOptions.transformation) {
      if (!(Object.keys(uploadOptions.transformation).includes("pre") || Object.keys(uploadOptions.transformation).includes("post"))) {
        respond(true, errorMessages.INVALID_TRANSFORMATION, callback);
        return;
      }
      if (Object.keys(uploadOptions.transformation).includes("pre") && !uploadOptions.transformation.pre) {
        respond(true, errorMessages.INVALID_PRE_TRANSFORMATION, callback);
        return;
      }
      if (Object.keys(uploadOptions.transformation).includes("post")) {
        if (Array.isArray(uploadOptions.transformation.post)) {
          var _iterator = _createForOfIteratorHelper(uploadOptions.transformation.post),
            _step;
          try {
            for (_iterator.s(); !(_step = _iterator.n()).done;) {
              var transformation = _step.value;
              if (transformation.type === "abs" && !(transformation.protocol || transformation.value)) {
                respond(true, errorMessages.INVALID_POST_TRANSFORMATION, callback);
                return;
              } else if (transformation.type === "transformation" && !transformation.value) {
                respond(true, errorMessages.INVALID_POST_TRANSFORMATION, callback);
                return;
              }
            }
          } catch (err) {
            _iterator.e(err);
          } finally {
            _iterator.f();
          }
        } else {
          respond(true, errorMessages.INVALID_POST_TRANSFORMATION, callback);
          return;
        }
      }
    }
    var formData = new FormData();
    var key;
    for (key in uploadOptions) {
      if (key) {
        if (key === "file" && typeof uploadOptions.file != "string") {
          formData.append('file', uploadOptions.file, String(uploadOptions.fileName));
        } else if (key === "tags" && Array.isArray(uploadOptions.tags)) {
          formData.append('tags', uploadOptions.tags.join(","));
        } else if (key === 'signature') {
          formData.append("signature", uploadOptions.signature);
        } else if (key === 'expire') {
          formData.append("expire", String(uploadOptions.expire));
        } else if (key === 'token') {
          formData.append("token", uploadOptions.token);
        } else if (key === "responseFields" && Array.isArray(uploadOptions.responseFields)) {
          formData.append('responseFields', uploadOptions.responseFields.join(","));
        } else if (key === "extensions" && Array.isArray(uploadOptions.extensions)) {
          formData.append('extensions', JSON.stringify(uploadOptions.extensions));
        } else if (key === "customMetadata" && _typeof$1(uploadOptions.customMetadata) === "object" && !Array.isArray(uploadOptions.customMetadata) && uploadOptions.customMetadata !== null) {
          formData.append('customMetadata', JSON.stringify(uploadOptions.customMetadata));
        } else if (key === "transformation" && _typeof$1(uploadOptions.transformation) === "object" && uploadOptions.transformation !== null) {
          formData.append(key, JSON.stringify(uploadOptions.transformation));
        } else if (uploadOptions[key] !== undefined) {
          formData.append(key, String(uploadOptions[key]));
        }
      }
    }
    formData.append("publicKey", options.publicKey);
    request(xhr, formData, callback);
  };
  var supportedTransforms = {
    width: "w",
    height: "h",
    aspectRatio: "ar",
    quality: "q",
    crop: "c",
    cropMode: "cm",
    focus: "fo",
    x: "x",
    y: "y",
    format: "f",
    radius: "r",
    background: "bg",
    border: "b",
    rotation: "rt",
    rotate: "rt",
    blur: "bl",
    named: "n",
    progressive: "pr",
    lossless: "lo",
    trim: "t",
    metadata: "md",
    colorProfile: "cp",
    defaultImage: "di",
    dpr: "dpr",
    effectSharpen: "e-sharpen",
    effectUSM: "e-usm",
    effectContrast: "e-contrast",
    effectGray: "e-grayscale",
    original: "orig",
    effectShadow: "e-shadow",
    effectGradient: "e-gradient",
    raw: "raw"
  };
  var DEFAULT_TRANSFORMATION_POSITION = "path";
  var QUERY_TRANSFORMATION_POSITION = "query";
  var VALID_TRANSFORMATION_POSITIONS = [DEFAULT_TRANSFORMATION_POSITION, QUERY_TRANSFORMATION_POSITION];
  var CHAIN_TRANSFORM_DELIMITER = ":";
  var TRANSFORM_DELIMITER = ",";
  var TRANSFORM_KEY_VALUE_DELIMITER = "-";
  var transformationUtils = {
    getDefault: function getDefault() {
      return DEFAULT_TRANSFORMATION_POSITION;
    },
    addAsQueryParameter: function addAsQueryParameter(options) {
      return options.transformationPosition === QUERY_TRANSFORMATION_POSITION;
    },
    validParameters: function validParameters(options) {
      if (typeof options.transformationPosition == "undefined") return false;
      return VALID_TRANSFORMATION_POSITIONS.indexOf(options.transformationPosition) != -1;
    },
    getTransformKey: function getTransformKey(transform) {
      if (!transform) {
        return "";
      }
      return supportedTransforms[transform] || supportedTransforms[transform.toLowerCase()] || "";
    },
    getChainTransformDelimiter: function getChainTransformDelimiter() {
      return CHAIN_TRANSFORM_DELIMITER;
    },
    getTransformDelimiter: function getTransformDelimiter() {
      return TRANSFORM_DELIMITER;
    },
    getTransformKeyValueDelimiter: function getTransformKeyValueDelimiter() {
      return TRANSFORM_KEY_VALUE_DELIMITER;
    }
  };
  var TRANSFORMATION_PARAMETER = "tr";
  function removeTrailingSlash(str) {
    if (typeof str == "string" && str[str.length - 1] == "/") {
      str = str.substring(0, str.length - 1);
    }
    return str;
  }
  function removeLeadingSlash(str) {
    if (typeof str == "string" && str[0] == "/") {
      str = str.slice(1);
    }
    return str;
  }
  function pathJoin(parts, sep) {
    var separator = sep || "/";
    var replace = new RegExp(separator + "{1,}", "g");
    return parts.join(separator).replace(replace, separator);
  }
  var buildURL = function buildURL(opts) {
    if (!opts.path && !opts.src) {
      return "";
    }
    var urlObj, isSrcParameterUsedForURL, urlEndpointPattern;
    try {
      if (opts.path) {
        urlEndpointPattern = new URL(opts.urlEndpoint).pathname;
        urlObj = new URL(pathJoin([opts.urlEndpoint.replace(urlEndpointPattern, ""), opts.path]));
      } else {
        urlObj = new URL(opts.src);
        isSrcParameterUsedForURL = true;
      }
    } catch (e) {
      console.error(e);
      return "";
    }
    for (var i in opts.queryParameters) {
      urlObj.searchParams.append(i, String(opts.queryParameters[i]));
    }
    var transformationString = constructTransformationString(opts.transformation);
    if (transformationString && transformationString.length) {
      if (transformationUtils.addAsQueryParameter(opts) || isSrcParameterUsedForURL) {
        urlObj.searchParams.append(TRANSFORMATION_PARAMETER, transformationString);
      } else {
        urlObj.pathname = pathJoin([TRANSFORMATION_PARAMETER + transformationUtils.getChainTransformDelimiter() + transformationString, urlObj.pathname]);
      }
    }
    if (urlEndpointPattern) {
      urlObj.pathname = pathJoin([urlEndpointPattern, urlObj.pathname]);
    } else {
      urlObj.pathname = pathJoin([urlObj.pathname]);
    }
    return urlObj.href;
  };
  function constructTransformationString(transformation) {
    if (!Array.isArray(transformation)) {
      return "";
    }
    var parsedTransforms = [];
    for (var i = 0, l = transformation.length; i < l; i++) {
      var parsedTransformStep = [];
      for (var key in transformation[i]) {
        if (transformation[i][key] === undefined || transformation[i][key] === null) continue;
        var transformKey = transformationUtils.getTransformKey(key);
        if (!transformKey) {
          transformKey = key;
        }
        if (transformation[i][key] === "-") {
          parsedTransformStep.push(transformKey);
        } else if (key === "raw") {
          parsedTransformStep.push(transformation[i][key]);
        } else {
          var value = transformation[i][key];
          if (transformKey === "di") {
            value = removeTrailingSlash(removeLeadingSlash(value || ""));
            value = value.replace(/\//g, "@@");
          }
          parsedTransformStep.push([transformKey, value].join(transformationUtils.getTransformKeyValueDelimiter()));
        }
      }
      parsedTransforms.push(parsedTransformStep.join(transformationUtils.getTransformDelimiter()));
    }
    return parsedTransforms.join(transformationUtils.getChainTransformDelimiter());
  }
  var url = function url(urlOpts, defaultOptions) {
    return buildURL(_objectSpread2$1(_objectSpread2$1({}, defaultOptions), urlOpts));
  };
  function mandatoryParametersAvailable(options) {
    return options.urlEndpoint;
  }
  var promisify = function promisify(thisContext, fn) {
    return function () {
      for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }
      if (args.length === fn.length && typeof args[args.length - 1] !== "undefined") {
        if (typeof args[args.length - 1] !== "function") {
          throw new Error("Callback must be a function.");
        }
        fn.call.apply(fn, [thisContext].concat(args));
      } else {
        return new Promise(function (resolve, reject) {
          var callback = function callback(err) {
            if (err) {
              return reject(err);
            } else {
              for (var _len2 = arguments.length, results = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
                results[_key2 - 1] = arguments[_key2];
              }
              resolve(results.length > 1 ? results : results[0]);
            }
          };
          args.pop();
          args.push(callback);
          fn.call.apply(fn, [thisContext].concat(args));
        });
      }
    };
  };
  var ImageKit = function () {
    function ImageKit(opts) {
      _classCallCheck(this, ImageKit);
      _defineProperty$1(this, "options", {
        sdkVersion: "javascript-".concat(version),
        publicKey: "",
        urlEndpoint: "",
        transformationPosition: transformationUtils.getDefault()
      });
      this.options = _objectSpread2$1(_objectSpread2$1({}, this.options), opts || {});
      if (!mandatoryParametersAvailable(this.options)) {
        throw errorMessages.MANDATORY_INITIALIZATION_MISSING;
      }
      if (!transformationUtils.validParameters(this.options)) {
        throw errorMessages.INVALID_TRANSFORMATION_POSITION;
      }
    }
    _createClass(ImageKit, [{
      key: "url",
      value: function url$1(urlOptions) {
        return url(urlOptions, this.options);
      }
    }, {
      key: "upload",
      value: function upload$1(uploadOptions, callbackOrOptions, options) {
        var callback;
        if (typeof callbackOrOptions === 'function') {
          callback = callbackOrOptions;
        } else {
          options = callbackOrOptions || {};
        }
        if (!uploadOptions || _typeof$1(uploadOptions) !== "object") {
          return respond(true, errorMessages.INVALID_UPLOAD_OPTIONS, callback);
        }
        var mergedOptions = _objectSpread2$1(_objectSpread2$1({}, this.options), options);
        var _ref = uploadOptions || {},
          userProvidedXHR = _ref.xhr;
        delete uploadOptions.xhr;
        var xhr = userProvidedXHR || new XMLHttpRequest();
        return promisify(this, upload)(xhr, uploadOptions, mergedOptions, callback);
      }
    }]);
    return ImageKit;
  }();

  function _iterableToArrayLimit(r, l) {
    var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (null != t) {
      var e,
        n,
        i,
        u,
        a = [],
        f = !0,
        o = !1;
      try {
        if (i = (t = t.call(r)).next, 0 === l) {
          if (Object(t) !== t) return;
          f = !1;
        } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
      } catch (r) {
        o = !0, n = r;
      } finally {
        try {
          if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return;
        } finally {
          if (o) throw n;
        }
      }
      return a;
    }
  }
  function ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
      var o = Object.getOwnPropertySymbols(e);
      r && (o = o.filter(function (r) {
        return Object.getOwnPropertyDescriptor(e, r).enumerable;
      })), t.push.apply(t, o);
    }
    return t;
  }
  function _objectSpread2(e) {
    for (var r = 1; r < arguments.length; r++) {
      var t = null != arguments[r] ? arguments[r] : {};
      r % 2 ? ownKeys(Object(t), !0).forEach(function (r) {
        _defineProperty(e, r, t[r]);
      }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) {
        Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
      });
    }
    return e;
  }
  function _regeneratorRuntime() {
    _regeneratorRuntime = function () {
      return e;
    };
    var t,
      e = {},
      r = Object.prototype,
      n = r.hasOwnProperty,
      o = Object.defineProperty || function (t, e, r) {
        t[e] = r.value;
      },
      i = "function" == typeof Symbol ? Symbol : {},
      a = i.iterator || "@@iterator",
      c = i.asyncIterator || "@@asyncIterator",
      u = i.toStringTag || "@@toStringTag";
    function define(t, e, r) {
      return Object.defineProperty(t, e, {
        value: r,
        enumerable: !0,
        configurable: !0,
        writable: !0
      }), t[e];
    }
    try {
      define({}, "");
    } catch (t) {
      define = function (t, e, r) {
        return t[e] = r;
      };
    }
    function wrap(t, e, r, n) {
      var i = e && e.prototype instanceof Generator ? e : Generator,
        a = Object.create(i.prototype),
        c = new Context(n || []);
      return o(a, "_invoke", {
        value: makeInvokeMethod(t, r, c)
      }), a;
    }
    function tryCatch(t, e, r) {
      try {
        return {
          type: "normal",
          arg: t.call(e, r)
        };
      } catch (t) {
        return {
          type: "throw",
          arg: t
        };
      }
    }
    e.wrap = wrap;
    var h = "suspendedStart",
      l = "suspendedYield",
      f = "executing",
      s = "completed",
      y = {};
    function Generator() {}
    function GeneratorFunction() {}
    function GeneratorFunctionPrototype() {}
    var p = {};
    define(p, a, function () {
      return this;
    });
    var d = Object.getPrototypeOf,
      v = d && d(d(values([])));
    v && v !== r && n.call(v, a) && (p = v);
    var g = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(p);
    function defineIteratorMethods(t) {
      ["next", "throw", "return"].forEach(function (e) {
        define(t, e, function (t) {
          return this._invoke(e, t);
        });
      });
    }
    function AsyncIterator(t, e) {
      function invoke(r, o, i, a) {
        var c = tryCatch(t[r], t, o);
        if ("throw" !== c.type) {
          var u = c.arg,
            h = u.value;
          return h && "object" == typeof h && n.call(h, "__await") ? e.resolve(h.__await).then(function (t) {
            invoke("next", t, i, a);
          }, function (t) {
            invoke("throw", t, i, a);
          }) : e.resolve(h).then(function (t) {
            u.value = t, i(u);
          }, function (t) {
            return invoke("throw", t, i, a);
          });
        }
        a(c.arg);
      }
      var r;
      o(this, "_invoke", {
        value: function (t, n) {
          function callInvokeWithMethodAndArg() {
            return new e(function (e, r) {
              invoke(t, n, e, r);
            });
          }
          return r = r ? r.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg();
        }
      });
    }
    function makeInvokeMethod(e, r, n) {
      var o = h;
      return function (i, a) {
        if (o === f) throw new Error("Generator is already running");
        if (o === s) {
          if ("throw" === i) throw a;
          return {
            value: t,
            done: !0
          };
        }
        for (n.method = i, n.arg = a;;) {
          var c = n.delegate;
          if (c) {
            var u = maybeInvokeDelegate(c, n);
            if (u) {
              if (u === y) continue;
              return u;
            }
          }
          if ("next" === n.method) n.sent = n._sent = n.arg;else if ("throw" === n.method) {
            if (o === h) throw o = s, n.arg;
            n.dispatchException(n.arg);
          } else "return" === n.method && n.abrupt("return", n.arg);
          o = f;
          var p = tryCatch(e, r, n);
          if ("normal" === p.type) {
            if (o = n.done ? s : l, p.arg === y) continue;
            return {
              value: p.arg,
              done: n.done
            };
          }
          "throw" === p.type && (o = s, n.method = "throw", n.arg = p.arg);
        }
      };
    }
    function maybeInvokeDelegate(e, r) {
      var n = r.method,
        o = e.iterator[n];
      if (o === t) return r.delegate = null, "throw" === n && e.iterator.return && (r.method = "return", r.arg = t, maybeInvokeDelegate(e, r), "throw" === r.method) || "return" !== n && (r.method = "throw", r.arg = new TypeError("The iterator does not provide a '" + n + "' method")), y;
      var i = tryCatch(o, e.iterator, r.arg);
      if ("throw" === i.type) return r.method = "throw", r.arg = i.arg, r.delegate = null, y;
      var a = i.arg;
      return a ? a.done ? (r[e.resultName] = a.value, r.next = e.nextLoc, "return" !== r.method && (r.method = "next", r.arg = t), r.delegate = null, y) : a : (r.method = "throw", r.arg = new TypeError("iterator result is not an object"), r.delegate = null, y);
    }
    function pushTryEntry(t) {
      var e = {
        tryLoc: t[0]
      };
      1 in t && (e.catchLoc = t[1]), 2 in t && (e.finallyLoc = t[2], e.afterLoc = t[3]), this.tryEntries.push(e);
    }
    function resetTryEntry(t) {
      var e = t.completion || {};
      e.type = "normal", delete e.arg, t.completion = e;
    }
    function Context(t) {
      this.tryEntries = [{
        tryLoc: "root"
      }], t.forEach(pushTryEntry, this), this.reset(!0);
    }
    function values(e) {
      if (e || "" === e) {
        var r = e[a];
        if (r) return r.call(e);
        if ("function" == typeof e.next) return e;
        if (!isNaN(e.length)) {
          var o = -1,
            i = function next() {
              for (; ++o < e.length;) if (n.call(e, o)) return next.value = e[o], next.done = !1, next;
              return next.value = t, next.done = !0, next;
            };
          return i.next = i;
        }
      }
      throw new TypeError(typeof e + " is not iterable");
    }
    return GeneratorFunction.prototype = GeneratorFunctionPrototype, o(g, "constructor", {
      value: GeneratorFunctionPrototype,
      configurable: !0
    }), o(GeneratorFunctionPrototype, "constructor", {
      value: GeneratorFunction,
      configurable: !0
    }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, u, "GeneratorFunction"), e.isGeneratorFunction = function (t) {
      var e = "function" == typeof t && t.constructor;
      return !!e && (e === GeneratorFunction || "GeneratorFunction" === (e.displayName || e.name));
    }, e.mark = function (t) {
      return Object.setPrototypeOf ? Object.setPrototypeOf(t, GeneratorFunctionPrototype) : (t.__proto__ = GeneratorFunctionPrototype, define(t, u, "GeneratorFunction")), t.prototype = Object.create(g), t;
    }, e.awrap = function (t) {
      return {
        __await: t
      };
    }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, c, function () {
      return this;
    }), e.AsyncIterator = AsyncIterator, e.async = function (t, r, n, o, i) {
      void 0 === i && (i = Promise);
      var a = new AsyncIterator(wrap(t, r, n, o), i);
      return e.isGeneratorFunction(r) ? a : a.next().then(function (t) {
        return t.done ? t.value : a.next();
      });
    }, defineIteratorMethods(g), define(g, u, "Generator"), define(g, a, function () {
      return this;
    }), define(g, "toString", function () {
      return "[object Generator]";
    }), e.keys = function (t) {
      var e = Object(t),
        r = [];
      for (var n in e) r.push(n);
      return r.reverse(), function next() {
        for (; r.length;) {
          var t = r.pop();
          if (t in e) return next.value = t, next.done = !1, next;
        }
        return next.done = !0, next;
      };
    }, e.values = values, Context.prototype = {
      constructor: Context,
      reset: function (e) {
        if (this.prev = 0, this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(resetTryEntry), !e) for (var r in this) "t" === r.charAt(0) && n.call(this, r) && !isNaN(+r.slice(1)) && (this[r] = t);
      },
      stop: function () {
        this.done = !0;
        var t = this.tryEntries[0].completion;
        if ("throw" === t.type) throw t.arg;
        return this.rval;
      },
      dispatchException: function (e) {
        if (this.done) throw e;
        var r = this;
        function handle(n, o) {
          return a.type = "throw", a.arg = e, r.next = n, o && (r.method = "next", r.arg = t), !!o;
        }
        for (var o = this.tryEntries.length - 1; o >= 0; --o) {
          var i = this.tryEntries[o],
            a = i.completion;
          if ("root" === i.tryLoc) return handle("end");
          if (i.tryLoc <= this.prev) {
            var c = n.call(i, "catchLoc"),
              u = n.call(i, "finallyLoc");
            if (c && u) {
              if (this.prev < i.catchLoc) return handle(i.catchLoc, !0);
              if (this.prev < i.finallyLoc) return handle(i.finallyLoc);
            } else if (c) {
              if (this.prev < i.catchLoc) return handle(i.catchLoc, !0);
            } else {
              if (!u) throw new Error("try statement without catch or finally");
              if (this.prev < i.finallyLoc) return handle(i.finallyLoc);
            }
          }
        }
      },
      abrupt: function (t, e) {
        for (var r = this.tryEntries.length - 1; r >= 0; --r) {
          var o = this.tryEntries[r];
          if (o.tryLoc <= this.prev && n.call(o, "finallyLoc") && this.prev < o.finallyLoc) {
            var i = o;
            break;
          }
        }
        i && ("break" === t || "continue" === t) && i.tryLoc <= e && e <= i.finallyLoc && (i = null);
        var a = i ? i.completion : {};
        return a.type = t, a.arg = e, i ? (this.method = "next", this.next = i.finallyLoc, y) : this.complete(a);
      },
      complete: function (t, e) {
        if ("throw" === t.type) throw t.arg;
        return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && e && (this.next = e), y;
      },
      finish: function (t) {
        for (var e = this.tryEntries.length - 1; e >= 0; --e) {
          var r = this.tryEntries[e];
          if (r.finallyLoc === t) return this.complete(r.completion, r.afterLoc), resetTryEntry(r), y;
        }
      },
      catch: function (t) {
        for (var e = this.tryEntries.length - 1; e >= 0; --e) {
          var r = this.tryEntries[e];
          if (r.tryLoc === t) {
            var n = r.completion;
            if ("throw" === n.type) {
              var o = n.arg;
              resetTryEntry(r);
            }
            return o;
          }
        }
        throw new Error("illegal catch attempt");
      },
      delegateYield: function (e, r, n) {
        return this.delegate = {
          iterator: values(e),
          resultName: r,
          nextLoc: n
        }, "next" === this.method && (this.arg = t), y;
      }
    }, e;
  }
  function _toPrimitive(t, r) {
    if ("object" != typeof t || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
      var i = e.call(t, r || "default");
      if ("object" != typeof i) return i;
      throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
  }
  function _toPropertyKey(t) {
    var i = _toPrimitive(t, "string");
    return "symbol" == typeof i ? i : String(i);
  }
  function _typeof(o) {
    "@babel/helpers - typeof";

    return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) {
      return typeof o;
    } : function (o) {
      return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, _typeof(o);
  }
  function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
      var info = gen[key](arg);
      var value = info.value;
    } catch (error) {
      reject(error);
      return;
    }
    if (info.done) {
      resolve(value);
    } else {
      Promise.resolve(value).then(_next, _throw);
    }
  }
  function _asyncToGenerator(fn) {
    return function () {
      var self = this,
        args = arguments;
      return new Promise(function (resolve, reject) {
        var gen = fn.apply(self, args);
        function _next(value) {
          asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
        }
        function _throw(err) {
          asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
        }
        _next(undefined);
      });
    };
  }
  function _defineProperty(obj, key, value) {
    key = _toPropertyKey(key);
    if (key in obj) {
      Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
      });
    } else {
      obj[key] = value;
    }
    return obj;
  }
  function _extends() {
    _extends = Object.assign ? Object.assign.bind() : function (target) {
      for (var i = 1; i < arguments.length; i++) {
        var source = arguments[i];
        for (var key in source) {
          if (Object.prototype.hasOwnProperty.call(source, key)) {
            target[key] = source[key];
          }
        }
      }
      return target;
    };
    return _extends.apply(this, arguments);
  }
  function _objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for (i = 0; i < sourceKeys.length; i++) {
      key = sourceKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      target[key] = source[key];
    }
    return target;
  }
  function _objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = _objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
      var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
      for (i = 0; i < sourceSymbolKeys.length; i++) {
        key = sourceSymbolKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
        target[key] = source[key];
      }
    }
    return target;
  }
  function _slicedToArray(arr, i) {
    return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
  }
  function _toConsumableArray(arr) {
    return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread();
  }
  function _arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return _arrayLikeToArray(arr);
  }
  function _arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
  }
  function _iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
  }
  function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
  }
  function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i];
    return arr2;
  }
  function _nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
  }
  function _nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
  }

  function createCommonjsModule(fn, basedir, module) {
  	return module = {
  		path: basedir,
  		exports: {},
  		require: function (path, base) {
  			return commonjsRequire(path, (base === undefined || base === null) ? module.path : base);
  		}
  	}, fn(module, module.exports), module.exports;
  }

  function commonjsRequire () {
  	throw new Error('Dynamic requires are not currently supported by @rollup/plugin-commonjs');
  }

  /**
   * Copyright (c) 2013-present, Facebook, Inc.
   *
   * This source code is licensed under the MIT license found in the
   * LICENSE file in the root directory of this source tree.
   */

  var ReactPropTypesSecret$1 = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';
  var ReactPropTypesSecret_1 = ReactPropTypesSecret$1;

  var ReactPropTypesSecret = ReactPropTypesSecret_1;

  function emptyFunction() {}
  function emptyFunctionWithReset() {}
  emptyFunctionWithReset.resetWarningCache = emptyFunction;
  var factoryWithThrowingShims = function () {
    function shim(props, propName, componentName, location, propFullName, secret) {
      if (secret === ReactPropTypesSecret) {
        // It is still safe when called from React.
        return;
      }
      var err = new Error('Calling PropTypes validators directly is not supported by the `prop-types` package. ' + 'Use PropTypes.checkPropTypes() to call them. ' + 'Read more at http://fb.me/use-check-prop-types');
      err.name = 'Invariant Violation';
      throw err;
    }
    shim.isRequired = shim;
    function getShim() {
      return shim;
    }
    // Important!
    // Keep this list in sync with production version in `./factoryWithTypeCheckers.js`.
    var ReactPropTypes = {
      array: shim,
      bigint: shim,
      bool: shim,
      func: shim,
      number: shim,
      object: shim,
      string: shim,
      symbol: shim,
      any: shim,
      arrayOf: getShim,
      element: shim,
      elementType: shim,
      instanceOf: getShim,
      node: shim,
      objectOf: getShim,
      oneOf: getShim,
      oneOfType: getShim,
      shape: getShim,
      exact: getShim,
      checkPropTypes: emptyFunctionWithReset,
      resetWarningCache: emptyFunction
    };
    ReactPropTypes.PropTypes = ReactPropTypes;
    return ReactPropTypes;
  };

  var require$$0 = factoryWithThrowingShims;

  var propTypes = createCommonjsModule(function (module) {
  /**
   * Copyright (c) 2013-present, Facebook, Inc.
   *
   * This source code is licensed under the MIT license found in the
   * LICENSE file in the root directory of this source tree.
   */

  {
    // By explicitly using `prop-types` you are opting into new production behavior.
    // http://fb.me/prop-types-in-prod
    module.exports = require$$0();
  }
  });

  var PropTypes = propTypes;

  var Props$2 = {
    publicKey: PropTypes.string,
    urlEndpoint: PropTypes.string,
    authenticator: PropTypes.func
  };
  var IKContextProps = _objectSpread2(_objectSpread2({}, Props$2), {}, {
    transformationPosition: PropTypes.oneOf(['path', 'query'])
  });
  var IKContextExtractedProps = _objectSpread2(_objectSpread2({}, IKContextProps), {}, {
    ikClient: PropTypes.instanceOf(ImageKit)
  });

  // Create the context
  var ImageKitContext = /*#__PURE__*/React.createContext({});

  /**
   * Provides a container for ImageKit components. Any option set in IKContext will be passed to the children.
   *
   * @example
   *<IKContext  publicKey="<public key>" urlEndpoint="url link">
   *    <!-- other tags -->
   *    <Image src={link}/>
   *</IKContext>
   */
  var IKContext = function IKContext(props) {
    var extractContextOptions = function extractContextOptions(mergedOptions) {
      var result = {};
      var propKeys = Object.keys(IKContextExtractedProps);
      for (var i = 0; i < propKeys.length; i++) {
        var key = propKeys[i];
        var value = mergedOptions[key];
        if (value) {
          result[key] = value;
        }
      }
      return result;
    };
    var mergedOptions = _objectSpread2({}, props);
    var contextOptionsExtracted = extractContextOptions(mergedOptions);
    if (contextOptionsExtracted.urlEndpoint && contextOptionsExtracted.urlEndpoint.trim() !== "") {
      contextOptionsExtracted.ikClient = new ImageKit({
        urlEndpoint: contextOptionsExtracted.urlEndpoint,
        // @ts-ignore
        sdkVersion: ""
      });
    }
    return /*#__PURE__*/React__default["default"].createElement(ImageKitContext.Provider, {
      value: contextOptionsExtracted
    }, props.children);
  };

  var Props$1 = {
    loading: PropTypes.oneOf(['lazy']),
    lqip: PropTypes.shape({
      active: PropTypes.bool,
      quality: PropTypes.number,
      threshold: PropTypes.number,
      blur: PropTypes.number,
      raw: PropTypes.string
    }),
    path: PropTypes.string,
    src: PropTypes.string,
    queryParameters: PropTypes.objectOf(PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired),
    transformation: PropTypes.arrayOf(PropTypes.object.isRequired),
    transformationPosition: PropTypes.oneOf(['path', 'query'])
  };

  var COMBINED_IMAGE_PROP_TYPES$1 = _objectSpread2(_objectSpread2({}, Props$2), Props$1);

  var fetchEffectiveConnection = function fetchEffectiveConnection() {
    try {
      return navigator.connection.effectiveType;
    } catch (ex) {
      return "4g";
    }
  };
  var getSrc = function getSrc(_ref, ikClient, contextOptions) {
    var urlEndpoint = _ref.urlEndpoint,
      lqip = _ref.lqip,
      src = _ref.src,
      path = _ref.path,
      transformation = _ref.transformation,
      transformationPosition = _ref.transformationPosition,
      queryParameters = _ref.queryParameters;
    var options;
    if (src) {
      options = {
        urlEndpoint: urlEndpoint || contextOptions.urlEndpoint,
        src: src,
        transformation: transformation || undefined,
        transformationPosition: transformationPosition || contextOptions.transformationPosition || undefined,
        queryParameters: queryParameters || {}
      };
    } else if (path) {
      options = {
        urlEndpoint: urlEndpoint || contextOptions.urlEndpoint,
        path: path,
        transformation: transformation || undefined,
        transformationPosition: transformationPosition || contextOptions.transformationPosition || undefined,
        queryParameters: queryParameters || {}
      };
    } else return {
      originalSrc: ""
    };
    var result = {
      originalSrc: ikClient.url(options)
    };
    if (lqip && lqip.active) {
      var quality = Math.round(lqip.quality || lqip.threshold || 20);
      var blur = Math.round(lqip.blur || 6);
      var newTransformation = options.transformation ? _toConsumableArray(options.transformation) : [];
      if (lqip.raw && typeof lqip.raw === "string" && lqip.raw.trim() !== "") {
        newTransformation.push({
          raw: lqip.raw.trim()
        });
      } else {
        newTransformation.push({
          quality: String(quality),
          blur: String(blur)
        });
      }
      result.lqipSrc = ikClient.url(_objectSpread2(_objectSpread2({}, options), {}, {
        transformation: newTransformation
      }));
    }
    return result;
  };
  var getIKElementsUrl = function getIKElementsUrl(_ref2, _ref3) {
    var _ref2$lqip = _ref2.lqip,
      lqip = _ref2$lqip === void 0 ? null : _ref2$lqip,
      loading = _ref2.loading;
    var intersected = _ref3.intersected,
      originalSrcLoaded = _ref3.originalSrcLoaded,
      originalSrc = _ref3.originalSrc,
      lqipSrc = _ref3.lqipSrc;
    /*
      No lazy loading no lqip
        src=originalImage
      No lazy loading lqip
        src=lqip
        src=originalImage (when loaded)
      lazy loading and no lqip
        src=''
        onIntersect:
        src=originalImage
      lazy loading and lqip
        src=lqip
        onIntersect:
        src=originalImage (when loaded)
    */
    var isLqipActive = function isLqipActive(lqip) {
      return lqip && lqip.active;
    };
    if (loading !== "lazy" && !isLqipActive(lqip)) {
      return originalSrc;
    } else if (loading !== "lazy" && isLqipActive(lqip)) {
      if (originalSrcLoaded) {
        return originalSrc;
      } else {
        return lqipSrc;
      }
    } else if (loading === "lazy" && !isLqipActive(lqip)) {
      if (intersected) {
        return originalSrc;
      } else {
        return "";
      }
    } else {
      //  if (loading === "lazy" && isLqipActive(lqip))
      if (intersected && originalSrcLoaded) {
        return originalSrc;
      } else {
        return lqipSrc;
      }
    }
  };

  var useImageKitComponent = function useImageKitComponent(props) {
    var contextOptions = React.useContext(ImageKitContext);
    var getIKClient = function getIKClient() {
      if (contextOptions && contextOptions.ikClient) {
        return contextOptions.ikClient;
      }
      var urlEndpoint = props.urlEndpoint;
      urlEndpoint = urlEndpoint || contextOptions && contextOptions.urlEndpoint;
      if (!urlEndpoint || urlEndpoint.trim() === "") {
        throw new Error("Missing urlEndpoint during initialization");
      }
      var ikClient = new ImageKit({
        urlEndpoint: urlEndpoint,
        // @ts-ignore
        sdkVersion: ""
      });
      return ikClient;
    };
    return {
      getIKClient: getIKClient
    };
  };

  var _excluded$2 = ["urlEndpoint", "authenticator", "publicKey", "loading", "lqip", "path", "src", "transformation", "transformationPosition", "queryParameters"];
  var IKImage = function IKImage(props) {
    var imageRef = React.useRef(null);
    var _useImageKitComponent = useImageKitComponent(_objectSpread2({}, props)),
      getIKClient = _useImageKitComponent.getIKClient;
    var contextOptions = React.useContext(ImageKitContext);
    var _useState = React.useState(undefined),
      _useState2 = _slicedToArray(_useState, 2),
      currentUrl = _useState2[0],
      setCurrentUrl = _useState2[1];
    var _useState3 = React.useState(""),
      _useState4 = _slicedToArray(_useState3, 2),
      originalSrc = _useState4[0],
      setOriginalSrc = _useState4[1];
    var _useState5 = React.useState(""),
      _useState6 = _slicedToArray(_useState5, 2),
      lqipSrc = _useState6[0],
      setLqipSrc = _useState6[1];
    var _useState7 = React.useState(false),
      _useState8 = _slicedToArray(_useState7, 2),
      originalSrcLoaded = _useState8[0],
      setOriginalSrcLoaded = _useState8[1];
    var _useState9 = React.useState(undefined),
      _useState10 = _slicedToArray(_useState9, 2),
      observe = _useState10[0],
      setObserve = _useState10[1];
    var _useState11 = React.useState(false),
      _useState12 = _slicedToArray(_useState11, 2),
      initialized = _useState12[0],
      setInitialized = _useState12[1];
    var _useState13 = React.useState(false),
      _useState14 = _slicedToArray(_useState13, 2),
      intersected = _useState14[0],
      setIntersected = _useState14[1];
    React.useEffect(function () {
      var _getSrc = getSrc(props, getIKClient(), contextOptions),
        newOriginalSrc = _getSrc.originalSrc,
        newLqipSrc = _getSrc.lqipSrc;
      setOriginalSrc(newOriginalSrc);
      setLqipSrc(newLqipSrc ? newLqipSrc : '');
      setInitialized(true);
    }, [contextOptions, props]);
    var updateImageUrl = /*#__PURE__*/function () {
      var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
        var url;
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return getIKElementsUrl(props, {
                originalSrc: originalSrc,
                lqipSrc: lqipSrc,
                intersected: intersected,
                contextOptions: contextOptions,
                initialzeState: initialized,
                originalSrcLoaded: originalSrcLoaded,
                observe: observe
              });
            case 2:
              url = _context.sent;
              // Include intersected state
              if (url) {
                setCurrentUrl(url);
              }
            case 4:
            case "end":
              return _context.stop();
          }
        }, _callee);
      }));
      return function updateImageUrl() {
        return _ref.apply(this, arguments);
      };
    }();
    var triggerOriginalImageLoad = function triggerOriginalImageLoad() {
      var img = new Image();
      img.onload = function () {
        setOriginalSrcLoaded(true);
      };
      img.src = originalSrc;
    };
    React.useEffect(function () {
      if (originalSrcLoaded) updateImageUrl();
    }, [originalSrcLoaded]);
    React.useEffect(function () {
      var image = imageRef.current;
      var loading = props.loading;
      if (initialized) {
        if (window && 'IntersectionObserver' in window && loading === "lazy") {
          var connectionType = fetchEffectiveConnection();
          var rootMargin = "1250px";
          if (connectionType !== "4g") rootMargin = "2500px";
          var imageObserver = new IntersectionObserver(function (entries) {
            var el = entries[0];
            if (el && el.isIntersecting && !intersected) {
              setIntersected(true);
              setObserve(function (prevObserver) {
                if (prevObserver) {
                  prevObserver.disconnect();
                }
                return undefined;
              });
              triggerOriginalImageLoad();
              updateImageUrl();
            }
          }, {
            rootMargin: "".concat(rootMargin, " 0px ").concat(rootMargin, " 0px")
          });
          if (image) {
            imageObserver.observe(image);
            setObserve(imageObserver);
          }
        } else {
          setIntersected(true);
          triggerOriginalImageLoad();
          updateImageUrl();
        }
      }
      return function () {
        if (observe) {
          observe.disconnect();
        }
      };
    }, [props, originalSrc, lqipSrc]);
    props.urlEndpoint;
      props.authenticator;
      props.publicKey;
      props.loading;
      props.lqip;
      props.path;
      props.src;
      props.transformation;
      props.transformationPosition;
      props.queryParameters;
      var restProps = _objectWithoutProperties(props, _excluded$2);
    return /*#__PURE__*/React__default["default"].createElement("img", _extends({
      alt: props.alt || "",
      src: currentUrl ? currentUrl : '',
      ref: imageRef
    }, restProps));
  };
  IKImage.propTypes = COMBINED_IMAGE_PROP_TYPES$1;

  var Props = {
    path: PropTypes.string,
    src: PropTypes.string,
    queryParameters: PropTypes.objectOf(PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired),
    transformation: PropTypes.arrayOf(PropTypes.object.isRequired),
    transformationPosition: PropTypes.oneOf(['path', 'query'])
  };

  var COMBINED_IMAGE_PROP_TYPES = _objectSpread2(_objectSpread2({}, Props$2), Props);

  var _excluded$1 = ["urlEndpoint", "publicKey", "authenticator", "path", "src", "transformation", "transformationPosition", "queryParameters"];
  var IKVideo = function IKVideo(props) {
    var videoRef = React.useRef(null);
    var _useState = React.useState({
        currentUrl: '',
        contextOptions: {}
      }),
      _useState2 = _slicedToArray(_useState, 2),
      state = _useState2[0],
      setState = _useState2[1];
    var _useImageKitComponent = useImageKitComponent(_objectSpread2({}, props)),
      getIKClient = _useImageKitComponent.getIKClient;
    var contextItems = React.useContext(ImageKitContext);
    React.useEffect(function () {
      var _getSrc = getSrc(props, getIKClient(), contextItems),
        originalSrc = _getSrc.originalSrc;
      setState(function (prevState) {
        return _objectSpread2(_objectSpread2({}, prevState), {}, {
          currentUrl: originalSrc,
          contextOptions: contextItems
        });
      });
    }, [contextItems, props]);
    var currentUrl = state.currentUrl;
    props.urlEndpoint;
      props.publicKey;
      props.authenticator;
      props.path;
      props.src;
      props.transformation;
      props.transformationPosition;
      props.queryParameters;
      var restProps = _objectWithoutProperties(props, _excluded$1);
    return /*#__PURE__*/React__default["default"].createElement("video", _extends({}, restProps, {
      ref: videoRef,
      key: currentUrl
    }), /*#__PURE__*/React__default["default"].createElement("source", {
      src: currentUrl,
      type: "video/mp4"
    }));
  };
  IKVideo.propTypes = COMBINED_IMAGE_PROP_TYPES;

  var _excluded = ["publicKey", "urlEndpoint", "authenticator", "fileName", "useUniqueFileName", "tags", "folder", "isPrivateFile", "customCoordinates", "responseFields", "onError", "onSuccess", "onUploadStart", "onUploadProgress", "validateFile", "webhookUrl", "overwriteFile", "overwriteAITags", "overwriteTags", "overwriteCustomMetadata", "extensions", "customMetadata", "transformation", "overrideParameters"];
  var IKUpload = /*#__PURE__*/React.forwardRef(function (props, ref) {
    var _useState = React.useState({}),
      _useState2 = _slicedToArray(_useState, 2),
      state = _useState2[0],
      setState = _useState2[1];
    var contextOptions = React.useContext(ImageKitContext);
    var _useImageKitComponent = useImageKitComponent(_objectSpread2({}, props)),
      getIKClient = _useImageKitComponent.getIKClient;
    React.useEffect(function () {
      var abort = function abort() {
        if (state.xhr) {
          state.xhr.abort();
        }
      };
      if (ref && _typeof(ref) === "object" && ref.hasOwnProperty("current")) {
        var refObject = ref;
        refObject.current.abort = abort;
      }
    }, [state.xhr, ref]);
    props.publicKey;
      props.urlEndpoint;
      props.authenticator;
      var fileName = props.fileName,
      useUniqueFileName = props.useUniqueFileName,
      tags = props.tags,
      folder = props.folder,
      isPrivateFile = props.isPrivateFile,
      customCoordinates = props.customCoordinates,
      responseFields = props.responseFields,
      onError = props.onError,
      onSuccess = props.onSuccess;
      props.onUploadStart;
      props.onUploadProgress;
      props.validateFile;
      var webhookUrl = props.webhookUrl,
      overwriteFile = props.overwriteFile,
      overwriteAITags = props.overwriteAITags,
      overwriteTags = props.overwriteTags,
      overwriteCustomMetadata = props.overwriteCustomMetadata,
      extensions = props.extensions,
      customMetadata = props.customMetadata,
      transformation = props.transformation;
      props.overrideParameters;
      var restProps = _objectWithoutProperties(props, _excluded);
    var uploadFile = function uploadFile(e) {
      var _e$target$files;
      var publicKey = props.publicKey || contextOptions.publicKey;
      var authenticator = props.authenticator || contextOptions.authenticator;
      var urlEndpoint = props.urlEndpoint || contextOptions.urlEndpoint;
      if (!publicKey || publicKey.trim() === "") {
        console.error("Missing publicKey");
        if (onError && typeof onError === "function") {
          onError({
            message: "Missing publicKey"
          });
        }
        return;
      }
      if (!authenticator) {
        console.error("The authenticator function is not provided.");
        if (onError && typeof onError === "function") {
          onError({
            message: "The authenticator function is not provided."
          });
        }
        return;
      }
      if (typeof authenticator !== 'function') {
        console.error("The provided authenticator is not a function.");
        if (onError && typeof onError === "function") {
          onError({
            message: "The provided authenticator is not a function."
          });
        }
        return;
      }
      if (!urlEndpoint || urlEndpoint.trim() === "") {
        console.error("Missing urlEndpoint");
        if (onError && typeof onError === "function") {
          onError({
            message: "Missing urlEndpoint"
          });
        }
        return;
      }
      var ikClient = getIKClient();
      var file = (_e$target$files = e.target.files) === null || _e$target$files === void 0 ? void 0 : _e$target$files[0];
      if (!file) {
        return;
      }
      if (props.validateFile && !props.validateFile(file)) {
        return;
      }
      if (props.onUploadStart && typeof props.onUploadStart === "function") {
        props.onUploadStart(e);
      }
      var overrideValues = {};
      if (props.overrideParameters && typeof props.overrideParameters === 'function') {
        overrideValues = props.overrideParameters(file) || {};
      }
      var xhr = new XMLHttpRequest();
      var progressCb = function progressCb(e) {
        if (props.onUploadProgress && typeof props.onUploadProgress === 'function') {
          props.onUploadProgress(e);
        }
      };
      xhr.upload.addEventListener('progress', progressCb);
      var params = {
        file: file,
        fileName: overrideValues.fileName || fileName || file.name,
        useUniqueFileName: overrideValues.useUniqueFileName || useUniqueFileName,
        tags: overrideValues.tags || tags,
        folder: overrideValues.folder || folder,
        isPrivateFile: overrideValues.isPrivateFile || isPrivateFile,
        customCoordinates: overrideValues.customCoordinates || customCoordinates,
        responseFields: responseFields,
        extensions: overrideValues.extensions || extensions,
        webhookUrl: overrideValues.webhookUrl || webhookUrl,
        overwriteFile: overrideValues.overwriteFile || overwriteFile,
        overwriteAITags: overrideValues.overwriteAITags || overwriteAITags,
        overwriteTags: overrideValues.overwriteTags || overwriteTags,
        overwriteCustomMetadata: overrideValues.overwriteCustomMetadata || overwriteCustomMetadata,
        customMetadata: overrideValues.customMetadata || customMetadata,
        signature: '',
        expire: 0,
        token: '',
        xhr: xhr,
        transformation: overrideValues.transformation || transformation
      };
      var authPromise = authenticator();
      if (!(authPromise instanceof Promise)) {
        if (onError && typeof onError === "function") {
          onError({
            message: "The authenticator function is expected to return a Promise instance."
          });
        }
        return;
      }
      authPromise.then(function (_ref) {
        var signature = _ref.signature,
          token = _ref.token,
          expire = _ref.expire;
        params['signature'] = signature;
        params['expire'] = expire;
        params['token'] = token;
        ikClient.upload(params, function (err, result) {
          if (err) {
            if (onError && typeof onError === "function") {
              console.log(err);
              onError(err);
            }
          } else {
            if (onSuccess && typeof onSuccess === "function") {
              onSuccess(result);
            }
          }
          xhr.upload.removeEventListener('progress', progressCb);
        }, {
          publicKey: publicKey
        });
        setState({
          xhr: xhr
        });
      })["catch"](function (data) {
        var error;
        if (data instanceof Array) {
          error = data[0];
        } else {
          error = data;
        }
        if (onError && typeof onError === "function") {
          onError({
            message: String(error)
          });
        }
        return;
      });
    };
    return /*#__PURE__*/React__default["default"].createElement("input", _extends({}, restProps, {
      ref: ref,
      type: "file",
      onChange: function onChange(e) {
        if (props.onChange && typeof props.onChange === "function") {
          props.onChange(e);
        }
        uploadFile(e);
      }
    }));
  });

  exports.IKContext = IKContext;
  exports.IKCore = ImageKit;
  exports.IKImage = IKImage;
  exports.IKUpload = IKUpload;
  exports.IKVideo = IKVideo;

  Object.defineProperty(exports, '__esModule', { value: true });

}));
